<template>
  <div tabindex="-1" class="modal-content">
    <header class="modal-header bg-primary text-white">
      <h5 class="modal-title">
        {{ options.dialogTitle ? options.dialogTitle : "Confirmation" }}
      </h5>
    </header>
    <div class="modal-body">
      <h6>{{ messageTitle }}</h6>
    </div>
    <footer class="modal-footer">
      <button
        v-for="(option, index) in options.options"
        :key="index"
        @click="handleConfirm(option)"
        type="button"
        class="btn btn-primary"
      >
        {{ option.label }}
      </button>
      <button
        @click="handleDismiss"
        type="button"
        class="btn bg-med-light-gray text-white"
      >
        {{ options.cancelText || "Cancel" }}
      </button>
    </footer>
  </div>
</template>

<script>
import DialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js"; // Include mixin

export default {
  name: "DialogMultipleActions",
  mixins: [DialogMixin],
  methods: {
    handleConfirm(option) {
      this.proceed(option); // included in DialogMixin
    },
    handleDismiss() {
      this.cancel(); // included in DialogMixin
    }
  },
  components: {}
};
</script>

<style scoped>
.modal-content {
  margin: -15px;
  width: auto;
}
</style>
